//
// LayoutElementWeights.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "../../MediaTarget";
import "./LayoutElementWeight";

var LayoutElementWeights = createModule("BIRD::LayoutElementWeights", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        unit: 7,
        mediaTarget: 1,
        weights: [1],
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default LayoutElementWeights;
